import React, {Fragment, useEffect, useState} from "react";
import {Banner, Header as MyHeader} from "../../components";
import {Card, Container, Grid} from "semantic-ui-react";
import {isUndefined} from "lodash";
// noinspection ES6CheckImport

import {FormattedMessage} from "react-intl";
import {fetchPostsRecent} from "../../redux/actions";
import {PostCard} from "../City/Posts/PostCard";

export const Columnists = ({from, blog, location, history, match, pages}) => {
    const {id, title} = match.params;
    const city = {
        id,
        title,
    };
    let path = `/columnists/${id}/${title}`;
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {

            // clean items
            setPosts([]);

            // start loading
            setIsLoading(true);

            try {

                // get posts
                const result = await fetchPostsRecent(city.id, 0, 'columnists', 1);

                // set posts
                setPosts(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [city.id]);

    useEffect(() => {
        if(posts.length !== 1){
            return;
        }

        const post = posts[0] || {};
        if(!post.category_id){
            return
        }

        const to = `${path}/home/${post.category_id}/${post.category.slug}#author=${post.category.author}`;

        window.top.location.href = to;

    }, [posts]);

    return (
        <React.Fragment>
            <MyHeader/>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column>
                            <h2 className={'ui header'}>
                                <FormattedMessage id={"Cult In Minas"}/>
                            </h2>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Card.Group stackable itemsPerRow={posts.length < 4 ? 0 : 4}>
                            {
                                posts.map((post) => {

                                    return (
                                        <PostCard
                                            key={`post-${post.id}`}
                                            post={post}
                                            path={path}
                                            home={1}
                                        />
                                    );
                                })
                            }
                        </Card.Group>
                    </Grid.Row>
                </Grid>
            </Container>
        </React.Fragment>
    );
};

